import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useTreinamentoFuncionarioCadastroViewModel } from "../../viewModels/treinamento_funcionario_cadastro_view_model";
import { Header } from "./components/header";
import { TransferList } from "./components/transfer_list";
import { DefaultFormMultiAutocomplete } from "../../../../../common/components/default_form_multi_autocomplete";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { FormMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { ReportListaTreinamentosModal } from "./components/report_lista_treinamentos_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { DefaultCheckBox } from "../../../../../common/components/default_checkbox";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";

import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import FormContainer from "../../../../../common/components/form_container";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DefaultFormInput from "../../../../../common/components/default_form_input";

/**
 * TreinamentoFuncionarioCadastro
 */

export const TreinamentoFuncionarioCadastro = () => {
  const viewModel = useTreinamentoFuncionarioCadastroViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="w-[150px] ">
              <PrimaryButton
                onClick={() => viewModel.handleReportModalOpenState(true)}>
                Relatórios
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <form onSubmit={viewModel.handleSubmit}>
        <div className="PAGE flex w-full gap-6 flex-col py-10 px-4 mb-16">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              RH
            </Link>
            <Typography className="text-primary-green">
              Treinamento
            </Typography>
          </Breadcrumbs>

          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Treinamento</h1>
              <RefreshButton onClick={viewModel.handleReloadPage} />
            </div>

            <div className="flex flex-row gap-2"></div>
          </div>
          {
            viewModel.errorMessage
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReloadPage} />
                </div>
              ) : (
                <>
                  <Header
                    selectedIdCargos={viewModel.filters.selectedCargoIds}
                    cargos={viewModel.filters.cargos ?? []}
                    selectedIdCentroCustos={viewModel.filters.selectedCentroCustoIds}
                    centroCustos={viewModel.filters.centroCustos ?? []}
                    onSelectedCargoChange={viewModel.handleSelectedCargosChange}
                    onSelectedCentroCustoChange={viewModel.handleSelectedCentroCustosChange}
                    onClearFilters={viewModel.handleClearFilters} />

                  <div className="w-full flex flex-col p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-stone-200 dark:border-stone-700 gap-4">
                    <FormContainer title="Treinamento" arrangement="fullRow" border={true}>
                      <DefaultFormMultiAutocomplete
                        name='treinamentoIds'
                        label='Selecione os Treinamentos'
                        required={true}
                        options={viewModel.filters.treinamentos ?? []}
                        getOptionLabel={x => x.descricao}
                        getOptionKey={x => x.idTreinamento}
                        reactHookForm={viewModel.hookForm}
                      />

                    </FormContainer>

                    <FormContainer title="Sobre o treinamento realizado" border={false}>
                      <>
                        <FormDatePickerInput
                          name='dataRealizacao'
                          label='Data Realização'
                          required={true}
                          reactHookForm={viewModel.hookForm} />

                        <DefaultFormInput
                          name='local'
                          label='Local'
                          required={true}
                          reactHookForm={viewModel.hookForm} />

                        <DefaultFormInput
                          name='instrutor'
                          label='Instrutor'
                          required={true}
                          reactHookForm={viewModel.hookForm} />

                        <div className="flex flex-col w-full">
                          <FormMaskedInput
                            name='prazoAvaliacao'
                            label='Prazo para Avaliar'
                            mask='000'
                            maskPlaceholder="___"
                            reactHookForm={viewModel.hookForm} />

                          <span className="w-full text-sm text-black dark:text-white">
                            Informe o número de dias ou 0 para treinamentos que não serão avaliados
                          </span>
                        </div>

                        <DefaultCheckBox
                          name='prazoAvaliacao'
                          label='Vincular assinatura dos instrutores'
                          value={viewModel.vincularAssinaturas}
                          onChangeValue={viewModel.handleVincularAssinaturasChange}
                        />
                      </>
                    </FormContainer>
                  </div>

                  {
                    viewModel.vincularAssinaturas === true &&
                    <div className="w-full flex flex-col p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-stone-200 dark:border-stone-700 gap-4">
                      <FormContainer title="Instrutores assinaturas" border={false}>
                        <>
                          <DefaultFormAutocomplete
                            name='instrutorAssinatura1'
                            label='Assinatura Instrutor 1'
                            options={viewModel.funcionariosAssinaturasDropdown}
                            getOptionKey={x => x.idFuncionarioAssinatura}
                            getOptionLabel={x => x.descricao}
                            getOptionDisabled={x => viewModel.selectedFuncionariosAssinaturasDropdown.includes(x.idFuncionarioAssinatura)}
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormAutocomplete
                            name='instrutorAssinatura2'
                            label='Assinatura Instrutor 2'
                            options={viewModel.funcionariosAssinaturasDropdown}
                            getOptionKey={x => x.idFuncionarioAssinatura}
                            getOptionLabel={x => x.descricao}
                            getOptionDisabled={x => viewModel.selectedFuncionariosAssinaturasDropdown.includes(x.idFuncionarioAssinatura)}
                            reactHookForm={viewModel.hookForm}
                          />

                          <DefaultFormAutocomplete
                            name='instrutorAssinatura3'
                            label='Assinatura Instrutor 3'
                            options={viewModel.funcionariosAssinaturasDropdown}
                            getOptionKey={x => x.idFuncionarioAssinatura}
                            getOptionLabel={x => x.descricao}
                            getOptionDisabled={x => viewModel.selectedFuncionariosAssinaturasDropdown.includes(x.idFuncionarioAssinatura)}
                            reactHookForm={viewModel.hookForm}
                          />
                        </>
                      </FormContainer>
                    </div>
                  }

                  <div className="w-full p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border-stone-200 dark:border-stone-700">
                    <TransferList
                      sourceList={viewModel.leftList}
                      destinationList={viewModel.rightList}
                      sourceListTitle='Selecione os funcionários'
                      destinationListTitle='Funcionários selecionados'
                      getItemKey={x => x.idFuncionario}
                      getItemLabel={x => x.nome}
                      onSelectionChange={viewModel.handleFuncionarioSelectionChange} />

                  </div>
                </>
              )
          }
        </div>

        <BottomBar>
          <div className="w-full h-full items-center justify-end flex p-4 gap-4">
            <div className="w-[130px]">
              {viewModel.saving
                ? (
                  <PrimaryButton>
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                    Salvar
                  </PrimaryButton>
                )}
            </div>
          </div>
        </BottomBar>
      </form>

      <ReportListaTreinamentosModal
        saving={viewModel.saving}
        open={viewModel.openReportListaTreinamentoModal}
        datas={viewModel.filters.datas ?? []}
        assinaturas={viewModel.filters.assinaturas ?? []}
        instrutores={viewModel.filters.instrutores ?? []}
        locais={viewModel.filters.locais ?? []}
        reactHookForm={viewModel.hookFormReport}
        onSubmit={viewModel.handleSubmitReport}
        onClose={() => viewModel.handleReportModalOpenState(false)}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
    </>
  );
}